export const elementInView = (el, scrollOffset = 0) => {
  const elementTop = el.getBoundingClientRect().top;

  return (
    elementTop <=
    ((window.innerHeight || document.documentElement.clientHeight) - scrollOffset)
  );
}

export const throttle = (callback, time) => {
    let throttleTimer;

    if (throttleTimer) return;

    throttleTimer = true;

    setTimeout(() => {
        callback;
        throttleTimer = false;
    }, time);
}

export const decimalCount = num => {
  // Convert to String
  const numStr = String(num);
  // String Contains Decimal
  if (numStr.includes('.')) {
     return numStr.split('.')[1].length;
  }
  // String Does Not Contain Decimal
  return 0;
}

export const getParameter = (parameterName) => {
  var result = null,
      tmp = [];
  location.search
      .substr(1)
      .split('&')
      .forEach(function (item) {
        tmp = item.split('=');
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      });
  return result;
}

export const validationCheck = {
  isEmailAddress:function(str) {
    var pattern =/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    return pattern.test(str);  // returns a boolean
  },
  isNotEmpty:function (str) {
      var pattern =/\S+/;
      return pattern.test(str);  // returns a boolean
  },
  isNumber:function(str) {
      var pattern = /^\d+$/;
      return pattern.test(str);  // returns a boolean
  },
  isSame:function(str1,str2){
      return str1 === str2;
  },
}
